import { toast } from "react-toastify";
import { useGeolocation } from "@uidotdev/usehooks";
import { CircularProgress, IconButton } from "@mui/material";
import MyLocationRoundedIcon from "@mui/icons-material/MyLocationRounded";

const FindMyLocation = ({ onClick }) => {
  const { error, latitude, longitude, loading } = useGeolocation({
    enableHighAccuracy: true,
    maximumAge: 5000,
    timeout: 10000,
  });

  const codes = [
    "نیاز به مجوز دسترسی مکان",
    "به دست آوردن موقعیت جغرافیایی ناموفق بود",
    "زمان دریافت اطلاعات مکانی پایان یافت",
  ];

  const findMe = () => {
    if (error) {
      toast.error(codes[error?.code]);
    } else if (!loading) {
      return onClick([longitude, latitude]);
    }
  };

  if (loading) {
    return <CircularProgress size={30} color="primary" />;
  }

  return (
    <IconButton
      size="small"
      color="primary"
      onClick={findMe}
      sx={{ bgcolor: "action.hover" }}
    >
      <MyLocationRoundedIcon fontSize="small" />
    </IconButton>
  );
};

export default FindMyLocation;
